import axios from "axios";
import { alignPropType } from "react-bootstrap/esm/types";
import AppRoutes from "../AppRoutes";

export const api = axios.create({
  // baseURL: "http://10.3.1.214:3333",
  baseURL: process.env.REACT_APP_BACKEND,
  strictSSL: false,
});

export const apiCEP = axios.create({
  baseURL: "https://viacep.com.br",
});

export const verificaCEP = async (N_cep) => {
  const cepValido = await apiCEP.get(`/ws/${N_cep}/json`);
  return cepValido;
};
export const createSession = async (email, chave) => {
  //console.log({ cpf, chave });
  return api.post(
    "/logar",
    { email, chave },
    { headers: { "Access-Control-Allow-Origin": true } },
  );
};

export const PegarDados1 = async () => {
  console.log("Y");
  const resultado = await api.get("/query");
  console.log("Z == ", resultado);
  return resultado;
};

export const PegarDados2 = async (di, df) => {
  const resultado = await api.post("/query2", {
    inicio: di,
    fim: df,
  });
  return resultado;
};
// https://carteirinhas.smrede.net.br/api/zip

export const apiFotos = axios.create({
  baseURL: "https://carteirinhas.smrede.net.br/api/",
  //baseURL: process.env.REACT_APP_BACKEND,
  strictSSL: false,
});
export const exportar_fotos = async (payload) => {
  const resposta = await apiFotos.post("/zip", payload, {});
  return resposta;
};

export const download_arquivo_gerado = async (url) => {
  return await api.get("https://carteirinhas.smrede.net.br" + url, {
    responseType: "blob", // <--- AQUI sim precisamos do Blob, pois é o download real
  });
};

export const total_monitora = async (di, df) => {
  const resultado = await api.post("/query3", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const fidelizacao = async (di, df) => {
  const resultado = await api.post("/query4", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados = async (di, df) => {
  const resultado = await api.post("/query5", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_unidade = async (di, df) => {
  const resultado = await api.post("/query14", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_total = async (di, df) => {
  const resultado = await api.post("/query20", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_segmento_total = async (di, df) => {
  const resultado = await api.post("/query43", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_segmento_total_2 = async (di, df) => {
  const resultado = await api.post("/query43b", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_serie_rede = async (di, df) => {
  const resultado = await api.post("/query46", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_unidade_25 = async (di, df) => {
  const resultado = await api.post("/query19", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolas_detalhes = async (di, df, un) => {
  const resultado = await api.post("/query11", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const bolas_detalhes_novos = async (di, df, un) => {
  const resultado = await api.post("/query60", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const bolas_detalhes_renovados = async (di, df, un) => {
  const resultado = await api.post("/query59", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const faturamento1 = async (di, df) => {
  const resultado = await api.post("/query50", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolas_detalhes_rede = async (di, df, un) => {
  const resultado = await api.post("/query49", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};
export const bolas_detalhes_rede_novos = async (di, df, un) => {
  const resultado = await api.post("/query58", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};
export const bolas_detalhes_rede_renovados = async (di, df, un) => {
  const resultado = await api.post("/query57", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const alunos_andamento = async (di, df, un) => {
  const resultado = await api.post("/query32", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const bolsas_media_unidade = async (di, df) => {
  const resultado = await api.post("/query17", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_media_unidade_contribuinte = async (di, df) => {
  const resultado = await api.post("/query22", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_diretor_unidade = async (di, df) => {
  const resultado = await api.post("/query16", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_diretor_unidade_novos = async (di, df) => {
  const resultado = await api.post("/query23", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_diretor_unidade_renovados = async (di, df) => {
  const resultado = await api.post("/query24", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_balcao_unidade = async (di, df) => {
  const resultado = await api.post("/query15", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_balcao_unidade_novos = async (di, df) => {
  const resultado = await api.post("/query25", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_balcao_unidade_renovados = async (di, df) => {
  const resultado = await api.post("/query26", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const status2 = async () => {
  const resultado = await api.get("/status2");
  return resultado.data;
};

export const bolsas_bolsao_unidade = async (di, df) => {
  const resultado = await api.post("/query27", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_bolsao_unidade_novos = async (di, df) => {
  const resultado = await api.post("/query28", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const metas_unidades = async (di, df) => {
  const resultado = await api.post("/query31", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const Alunos_Socio_Economico = async (di, df) => {
  const resultado = await api.post("/query61", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const anuidade_unidades = async (di, df) => {
  const resultado = await api.post("/query30", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_bolsao_unidade_renovados = async (di, df) => {
  const resultado = await api.post("/query29", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const fidelizacao_turma = async (di, df, un) => {
  const resultado = await api.post("/query12", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const fidelizacao_serie = async (di, df, un) => {
  const resultado = await api.post("/query44", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const fidelizacao_serie_rede = async (di, df) => {
  const resultado = await api.post("/query45", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const fidelizacao_seg_rede = async (di, df) => {
  const resultado = await api.post("/query47", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const fidelizacao_seg_unidade = async (di, df, un) => {
  const resultado = await api.post("/query48", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const bolsa_unidade = async (di, df, un) => {
  const resultado = await api.post("/query13", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const alunos_turno_unidade = async (di, df, un) => {
  const resultado = await api.post("/query56", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const bolsas = async (di, df) => {
  const resultado = await api.post("/query6", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const pagamentos_pix = async (di, df, st) => {
  const resultado = await api.post("/query40", {
    inicio: di,
    fim: df,
    status: st,
  });
  return resultado.data;
};

export const lista_tabela_pagamentos_mol = async () => {
  const resultado = await api.post("/query81");
  return resultado;
};

export const busca_pente_fino = async (un, ano) => {
  const resultado = await api.post("/query80", {
    unidade: un,
    ano: ano,
  });
  return resultado.data;
};

export const busca_censo = async () => {
  const resultado = await api.post("/geo6");
  return resultado;
};

export const pagamentos_credito = async (di, df, st) => {
  const resultado = await api.post("/query41", {
    inicio: di,
    fim: df,
    status: st,
  });
  return resultado.data;
};

export const agendamentos = async (un, td) => {
  const resultado = await api.post("/query42", {
    unidade: un,
    status: td,
  });
  return resultado.data;
};

export const bolsas_rede = async () => {
  const resultado = await api.post("/query37");
  return resultado;
};
export const bolsas_rede_novos = async () => {
  const resultado = await api.post("/query38");
  return resultado;
};
export const bolsas_rede_renovados = async () => {
  const resultado = await api.post("/query39");
  return resultado;
};

export const renovacao_serie_compara = async () => {
  const resultado = await api.post("/query51");
  return resultado;
};

export const renovacao_serie_compara_unidade = async (un) => {
  const resultado = await api.post("/query54", {
    unidade: un,
  });
  return resultado;
};

export const bolsas_tipo = async (di, df) => {
  const resultado = await api.post("/query18", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const bolsas_tipo_unidade_novos = async (di, df) => {
  const resultado = await api.post("/query35", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const bolsas_tipo_unidade_renovados = async (di, df) => {
  const resultado = await api.post("/query36", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const bolsas_tipo_novos = async (di, df) => {
  const resultado = await api.post("/query33", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const bolsas_tipo_renovados = async (di, df) => {
  const resultado = await api.post("/query34", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const bolsas_media = async (di, df) => {
  const resultado = await api.post("/query7", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const alunos_situacao = async (di, df) => {
  const resultado = await api.post("/query8", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const material = async () => {
  const resultado = await api.post("/query10");
  return resultado.data;
};

export const mensalidade_media = async (di, df) => {
  const resultado = await api.post("/query9", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const mensalidade_media_rede = async (di, df) => {
  const resultado = await api.post("/query21", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const pega_dados_carteirinhas = async (di, df) => {
  const resultado = await api.post("/query69", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const pega_renovacao_serie_unidade = async (di, df) => {
  const resultado = await api.post("/query72", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const pega_alunos_planos = async (di, df) => {
  const resultado = await api.post("/query73", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const pega_pedidos_carteirinhas = async () => {
  const resultado = await api.post("/query70");
  return resultado.data;
};
export const pega_confere_carteirinhas = async () => {
  const resultado = await api.post("/query70A");
  return resultado.data;
};

export const pega_nao_renovados = async () => {
  const resultado = await api.post("/query71");
  return resultado.data;
};

export const mat_acumuladas = async () => {
  const resultado = await api.post("/query52");
  return resultado.data;
};

export const mat_acumuladas_unidade = async () => {
  const resultado = await api.post("/query68");
  return resultado.data;
};

export const mat_acumuladas_uni = async (di, df, un) => {
  const resultado = await api.post("/query53", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const alunos_geo = async () => {
  const resultado = await api.post("/geo");
  return resultado.data;
};
export const alunos_geo_bairro = async () => {
  const resultado = await api.post("/geo2");
  return resultado.data;
};

export const alunos_geo_cidade = async () => {
  const resultado = await api.post("/geo3");
  return resultado.data;
};
export const alunos_geo_mediana = async () => {
  const resultado = await api.post("/geo4");
  return resultado.data;
};
export const alunos_geo_raio_de_90_porcento = async () => {
  const resultado = await api.post("/geo5");
  return resultado.data;
};

export const geo_buscar_escola = async (un, rg) => {
  const resultado = await api.post("/buscar_escola", {
    unidade: un,
    range: rg,
  });
  return resultado.data;
};

export const geo_busca_populacao = async (un, rg) => {
  const resultado = await api.post("/busca_populacao", {
    unidade: un,
    range: rg,
  });
  return resultado.data;
};

export const geo_busca_alunos = async (un, rg) => {
  const resultado = await api.post("/busca_alunos", {
    unidade: un,
    range: rg,
  });
  return resultado.data;
};

export const alunos_turma = async (un) => {
  const resultado = await api.post("/query74", {
    unidade: un,
  });
  return resultado.data;
};

export const Pega_QTD_turmas = async () => {
  const resultado = await api.post("/query75");
  return resultado.data;
};

export const Pega_QTD_alunos_Seg = async () => {
  const resultado = await api.post("/query75a");
  return resultado.data;
};

export const Pegar_dados_planos_ciclos = async () => {
  const resultado = await api.post("/query77");
  return resultado.data;
};

export const Lista_cancelados = async () => {
  const resultado = await api.post("/query78");
  return resultado.data;
};

export const Lista_Meus_Alunos = async () => {
  const resultado = await api.post("/query79");
  return resultado.data;
};

export const pega_estimativa_geral = async () => {
  const resultado = await api.post("/query55");
  return resultado.data;
};

export const pega_historico_bolsa = async () => {
  const resultado = await api.post("/query82");
  return resultado.data;
};

export const permite_acesso = async (Nusuario, Ntoken, Npagina) => {
  const resultado = await api.post("/permite_acesso", {
    usuario: Nusuario,
    token: Ntoken,
    pagina: Npagina,
  });
  return resultado.data;
};

export const permite_acesso_fondation = async (Npagina, Nunidade) => {
  console.log("npagina", Npagina);
  const resultado = await api.post("/permite_acesso", {
    pagina: Npagina,
    unidade: Nunidade,
  });
  console.log("resultado1", resultado.data);
  if (resultado.data === true) return true;
  else return false;
};

export const envia_CC = async (n_id) => {
  const resultado = await api.post("/sendCC", { id: n_id });
  return resultado;
};

export const lista_proventos = async (n_cpf) => {
  console.log("recebi_cpf:", n_cpf);
  const resultado = await api.post("/lista_proventos", { cpf: n_cpf });
  return resultado.data;
};

export const lista_funcionarios = async () => {
  const resultado = await api.post("/lista_funcionarios");
  return resultado.data;
};

export const consulta_funcionario = async (n_cpf) => {
  const resultado = await api.post("/consulta_funcionario", { cpf: n_cpf });
  return resultado.data;
};

export const salva_funcionario = async (n_cpf) => {
  const resultado = await api.post("/salva_funcionario", { cpf: n_cpf });
  return resultado.data;
};

export const lista_matriculas = async (n_cpf) => {
  const resultado = await api.post("/lista_matricula", { cpf: n_cpf });
  return resultado.data;
};

export const adiciona_matricula = async (n_cpf, n_matricula) => {
  const resultado = await api.post("/adiciona_matricula", {
    cpf: n_cpf,
    matricula: n_matricula,
  });
  return resultado.data;
};

export const remove_matricula = async (n_cpf, n_matricula) => {
  const resultado = await api.post("/apaga_matricula", {
    cpf: n_cpf,
    matricula: n_matricula,
  });
  return resultado.data;
};

export const gravar_chave = async (Ntoken, Nchave) => {
  const resultado = await api.post("/grava_chave", {
    token: Ntoken,
    chave: Nchave,
  });
  return resultado;
};

export const validaToken = async (N_token) => {
  const resultado = await api.post("/valida_token", {
    token: N_token,
  });
  return resultado;
};

export const enviar_reset = async (Nemail) => {
  const resultado = await api.post("/reset_senha", {
    email: Nemail,
  });
  return resultado;
};

export const uploadArq = async (Nmes, Nano, Ntipo, Narq) => {
  const restulado = await api.post("/upload_arq", {
    mes_ref: Nmes,
    ano_ref: Nano,
    tipo_doc: Ntipo,
    arquivo: Narq,
  });
};

export const contaDocs = async () => {
  const resultado = await api.get("/proventos_cadastrados");
  return resultado.data;
};

export const listaDocs = async (Nmes, Nano, Ntipo, Nnome) => {
  console.log("X", Nmes, Nano, Ntipo, Nnome);
  const resultado = await api.post("/proventos_usuarios", {
    mes_ref: Nmes,
    ano_ref: Nano,
    tipo_doc: Ntipo,
    nome: Nnome,
  });
  return resultado.data;
};

export const integral_novos = async (di, df) => {
  const resultado = await api.post("/query63", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const integral_renovados = async (di, df) => {
  const resultado = await api.post("/query62", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const integral_rede = async (di, df) => {
  const resultado = await api.post("/query64", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const integral_novos_un = async (di, df, un) => {
  const resultado = await api.post("/query66", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const integral_renovados_un = async (di, df, un) => {
  const resultado = await api.post("/query65", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const integral_rede_un = async (di, df, un) => {
  const resultado = await api.post("/query67", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

/*
export const lista_unidadeCPF = async (n_cpf) => {
  const resultado = await api.post("/lista_unidadeCPF", { cpf: n_cpf });
  return resultado.data;
};

export const lista_usuario = async (Nunidade) => {
  const resultado = await api.post("/lista_usuarios", { unidade: Nunidade });
  return resultado.data;
};

export const dados_usuario = async (n_cpf) => {
  const resultado = await api.post("/dados_usuario", { cpf: n_cpf });
  return resultado.data;
};

export const grava_usuario = async ({ dados }) => {
  const resultado = await api.post("/gravar_usuario", { dados });
  return resultado;
};

export const lista_unidades = async () => {
  const resultado = await api.post("/lista_unidades");
  return resultado.data;
};

export const lista_perfil_usuario = async (Ncpf, Nunidade) => {
  const resultado = await api.post("/perfil_usuario", {
    cpf: Ncpf,
    unidade: Nunidade,
  });
  return resultado.data;
};

export const atualiza_perfil_usuario = async (Ncpf, Ncod, Nuni, Nstatus) => {
  const resultado = await api.post("/atualiza_perfil", {
    cpf: Ncpf,
    cod_perfil: Ncod,
    unidade: Nuni,
    marcado: Nstatus,
  });
  return resultado;
};

export const gravar_chave = async (Ntoken, Nchave) => {
  const resultado = await api.post("/grava_chave", {
    token: Ntoken,
    chave: Nchave,
  });
  return resultado;
};

export const enviar_reset = async (Nemail) => {
  const resultado = await api.post("/reset_senha", {
    email: Nemail,
  });
};

export const lista_Pessoas = async () => {
  const resultado = await api.get("/lista_Pessoa");
  return resultado;
};

export const grava_Pessoa = async (dados) => {
  const resultado = await api.post("/gravar_pessoa", dados);
  return resultado;
};

export const grava_email = async (dados) => {
  const resultado = await api.post("/gravar_email", dados);
  return resultado;
};

export const grava_telefone = async (dados) => {
  const resultado = await api.post("/gravar_telefone", dados);
  return resultado;
};

export const grava_endereco = async (dados) => {
  const resultado = await api.post("/gravar_endereco", dados);
  return resultado;
};

export const constulta_Pessoa = async (nid) => {
  const resultado = await api.get(`/consulta_pessoa/${nid}`);
  return resultado;
};

export const atualiza_pessoa = async (nid, dados) => {
  const resultado = await api.post(`/atualiza_pessoa/${nid}`, dados);
  return resultado;
};

export const atualiza_endereco = async (nid, dados) => {
  const resultado = await api.post(`/atualiza_endereco/${nid}`, dados);
  return resultado;
};

export const constulta_Email = async (nid) => {
  const resultado = await api.get(`/consulta_email/${nid}`);
  return resultado;
};

export const remove_email = async (nid) => {
  const resultado = await api.delete(`/apaga_email/${nid}`);
  return resultado;
};

export const constulta_Telefone = async (nid) => {
  const resultado = await api.get(`/consulta_telefone/${nid}`);
  return resultado;
};

export const remove_telefone = async (nid) => {
  const resultado = await api.delete(`/apaga_telefone/${nid}`);
  return resultado;
};

export const constulta_endereco = async (nid) => {
  const resultado = await api.get(`/consulta_endereco/${nid}`);
  return resultado;
};



export const pegarStatus = async () => {
  return api.get("/status");
};

export const novoAcesso = async (N_email) => {
  return api.post("/acesso", { email: N_email });
};

export const sendMail = async (opcao) => {
  return api.post(
    "/sendmail",
    { opcao },
    { headers: { "Access-Control-Allow-Origin": true } }
  );
};

export const consultaCpf = async (N_CPF) => {
  return api.post("/consultaCpfPsmce", { cpf: N_CPF });
};

export const validaToken = async (N_token) => {
  const emailValido = await api.get(`/validaToken/${N_token}`);
  return emailValido.data.email;
};

export const confirmaToken = async (N_token) => {
  const emailValido = await api.get(`/validaToken/${N_token}`);
  return emailValido;
};

export const DadosCPFSMCE = async (N_CPF) => {
  const resultado = await api.post("/consultaCpfPsmce", { cpf: N_CPF });
  return resultado;
};

export const gravarNovaPessoa = async ({ dados, token }) => {
  const resultado = await api.post("/confirmar", { dados, token });
  return resultado;
};

export const gerarChave = async (token) => {
  const resultado = await api.post("/gerarChave", token);
  return resultado;
};

export const resetChave = async (email) => {
  const resultado = await api.post("/ResetChave", email);
  return resultado;
};

export const existeCadastro = async (n_email) => {
  const resultado = await api.post(
    "/emailemPessoa",
    { email: n_email },
    { headers: { "Access-Control-Allow-Origin": true } }
  );
  return resultado.data;
};

export const consultaPessoa = async (n_cpf) => {
  const resultado = await api.post("/consultaCpfPessoa", { cpf: n_cpf });
  return resultado.data;
};

export const consultaAluno = async (n_mat) => {
  const resultado = await api.post("/dadosAluno", { matricula: n_mat });
  // console.log("dmat", n_mat);
  return resultado.data;
};

export const consultaPendenciaCpf = async (n_cpf) => {
  const resultado = await api.post("/pendenciaCpf", { cpf: n_cpf });
  if (resultado.data.length === 0) {
    return false;
  } else {
    return true;
  }
};

export const listaMatriculasCPF = async (n_cpf) => {
  const resultado = await api.get(`/cadastro/${n_cpf}`);
  return resultado.data;
};

export const buscardadosAluno = async (n_matricula) => {
  const resultado = await api.post("/dadosAluno", { matricula: n_matricula });
  return resultado.data;
};

export const gravaPessoa = async ({ dados }) => {
  const resultado = await api.post("/gravarCpf", { dados });
  return resultado;
};

export const buscarDadosContrato = async (n_matricula) => {
  const resultado = await api.post("/dadosContrato", {
    matricula: n_matricula,
  });
  return resultado.data;
};

export const gravaAluno = async ({ dados }) => {
  const resultado = await api.post("/gravarAluno", { dados });
  return resultado;
};

export const gravaContrato = async ({ dados }) => {
  const resultado = await api.post("/gravarContrato", { dados });
  return resultado;
};

export const buscaPlano = async (n_matricula) => {
  const resultado = await api.post("/dadosPlano", { matricula: n_matricula });
  return resultado.data;
};

export const mostrarPDFContrato = async (n_matricula) => {
  const resultado = await api.post("/contratoPdf", { matricula: n_matricula });
  return resultado.data;
};

export const consultaAgenda = async (n_dia, n_unidade) => {
  const resultado = await api.post("/consultaAgenda", {
    dia: n_dia,
    unidade: n_unidade,
  });
  return resultado.data;
};

export const gravaAgenda = async (n_dia, n_unidade, n_matricula) => {
  console.log("apiM", n_matricula);

  const resultado = await api.post("/AtualizaAgenda", {
    dia: n_dia,
    unidade: n_unidade,
    matricula: n_matricula,
  });
  return resultado.data;
};

export const enviarPDFContrato = async (n_matricula) => {
  const resultado = await api.post("/sendPDF", { matricula: n_matricula });
  return resultado.data;
};

export const verificaAgenda = async (n_matricula) => {
  const resultado = await api.post("/verificaAgenda", {
    matricula: n_matricula,
  });
  return resultado.data;
};

export const buscaUnidade = async (n_matricula) => {
  const resultado = await api.post("/unidade", { matricula: n_matricula });
  return resultado.data;
};

export const buscaFoto = async (n_matricula) => {
  const resultado = await api.post("/fotoAluno", { matricula: n_matricula });
  return resultado.data;
};
*/
